import React, { useState } from 'react'
import Layout from '../../Components/Layout';
import { Icon } from '@iconify/react';
import LightText, { BigerTexts, btnfont } from '../../Assets/CSS/Text';
import { Newbtn } from '../../Assets/CSS/Button';
import ClearanceTask from './ClearanceTask';
import ExitInterviewQuestion from './ExitInterviewQuestion';

const OffboardingConfig = () => {
    const [statusFilter, setStatusFilter] = useState('Clearance Tasks');
    const isMobile = window.innerWidth <= 768;

    return (
        <Layout>
            <div className="backgound-main-content px-md-3 px-sm-0">
                <h6 className="mt-2" style={BigerTexts}>System Admin Configuration</h6>
                <p style={LightText}>Configure offboarding workflows, tasks, and templates</p>
                {/* ================= Filter Tabs ================= */}
                <div
                    style={{ borderBottom: "2px solid #DBDBDB" }}
                >
                    <div className="d-flex flex-wrap gap-3">
                        {["Clearance Tasks", "Exit Interview Questions"].map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${statusFilter === tab ? "active" : ""}`}
                                onClick={() => setStatusFilter(tab)}
                                style={{
                                    color: statusFilter === tab ? "#00AFEF" : "#909090",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: isMobile ? "14px" : "16px",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ================= Content BELOW border ================= */}
                <div className="mt-2">
                    {statusFilter === "Clearance Tasks" && <ClearanceTask />}

                    {statusFilter === "Exit Interview Questions" && <ExitInterviewQuestion />}
                </div>

            </div>
        </Layout>
    );
};

export default OffboardingConfig